<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-lg-6 content-page">
      <ish-breadcrumb></ish-breadcrumb>

      <h1>{{ 'helpdesk.contact_us.heading' | translate }}</h1>

      <ng-container *ngIf="(success$ | async) === undefined; else contactConfirmation">
        <div class="row">
          <div class="col-xl-12">
            <div class="container-fluid border rounded p-4">
              <ish-contact-form (request)="createRequest($event)"></ish-contact-form>
              <div [innerHTML]="'helpdesk.user_service.message' | translate"></div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #contactConfirmation>
        <ish-contact-confirmation [success]="success$ | async"></ish-contact-confirmation>
      </ng-template>

      <ish-loading *ngIf="loading$ | async"></ish-loading>
    </div>
  </div>
</div>
